export const METADATA_TYPE = {
  mechanism: "mechanism",
  vulncat: "vulncat",
};
